<template>
    <div v-if="document" class="sidebar-filters">
        <div class="sidebar-header">
            <div class="header-left">
                <i class="dx-icon-info icon-main"></i>
                <span class="sidebar-title">Detalii Document</span>
            </div>
            <div class="header-actions">
                <DxButton
                    v-if="!readonlyLocal"
                    text="Salvează"
                    icon="save"
                    type="success"
                    styling-mode="contained"
                    class="save-header-btn"
                    @click="saveClicked"
                />
                <DxButton
                    :icon="readonlyLocal ? 'edit' : 'revert'"
                    :styling-mode="readonlyLocal ? 'text' : 'contained'"
                    :type="readonlyLocal ? 'normal' : 'danger'"
                    class="action-btn-small"
                    @click="toggleEdit"
                />
                <DxButton
                    icon="close"
                    styling-mode="text"
                    class="close-sidebar-btn-small"
                    @click="$emit('close-sidebar')"
                />
            </div>
        </div>

        <div class="filters-container">
            <DxAccordion
                :items="accordionItems"
                :multiple="false"
                :collapsible="true"
                v-model:selected-item-keys="selectedAccordionKeys"
                key-expr="id"
                class="filters-accordion"
            >
                <template #title="{ data }">
                    <div class="accordion-title-wrapper">
                        <i :class="data.icon"></i>
                        <span class="accordion-title-text">{{ data.title }}</span>
                    </div>
                </template>

                <template #item="{ data }">
                    <div class="accordion-item-content">
                        <!-- Identitate -->
                        <div v-if="data.id === 'identity'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxTextBox
                                    label="Număr"
                                    label-mode="floating"
                                    v-model:value="form.Numar"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Categorie"
                                    label-mode="floating"
                                    :data-source="dsCategorieDocumente"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    :value="displayCategorieId"
                                    :disabled="true"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Tip"
                                    label-mode="floating"
                                    :data-source="dsTipDocumente"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    v-model:value="form.TipId"
                                    :disabled="readonlyLocal"
                                    @value-changed="onTipChanged"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Partener"
                                    label-mode="floating"
                                    :data-source="dsPartener"
                                    value-expr="ID"
                                    display-expr="Nume"
                                    v-model:value="form.PartenerId"
                                    :disabled="readonlyLocal"
                                />
                            </div>
                        </div>

                        <!-- Financiar -->
                        <div v-if="data.id === 'financial'" class="filter-group-inner">
                            <div class="form-field-grid">
                                <DxNumberBox
                                    label="Valoare"
                                    label-mode="floating"
                                    :value="viewDoc.Valoare"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    label="TVA %"
                                    label-mode="floating"
                                    v-model:value="form.Tva"
                                    format="#0"
                                    :disabled="readonlyLocal"
                                />

                                <DxNumberBox
                                    label="Valoare TVA"
                                    label-mode="floating"
                                    :value="viewDoc.ValoareTva"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    label="Total"
                                    label-mode="floating"
                                    :value="viewDoc.Total"
                                    format="#,##0.00"
                                    :disabled="true"
                                />
                            </div>

                            <div class="form-field-grid mt-2">
                                <DxLookup
                                    label="Valută"
                                    label-mode="floating"
                                    :data-source="dsValute"
                                    value-expr="Id"
                                    display-expr="Simbol"
                                    v-model:value="form.ValutaId"
                                    :disabled="readonlyLocal"
                                    @value-changed="onValutaChanged"
                                />

                                <DxNumberBox
                                    label="Curs"
                                    label-mode="floating"
                                    :value="form.Curs"
                                    format="#,##0.0000"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    label="Sold"
                                    label-mode="floating"
                                    :value="viewDoc.Sold"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    label="Adaos"
                                    label-mode="floating"
                                    :value="viewDoc.Adaos"
                                    format="#,##0.00"
                                    :disabled="true"
                                />
                            </div>
                        </div>

                        <!-- Calendar -->
                        <div v-if="data.id === 'calendar'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxDateBox
                                    label="Data Contabilă"
                                    label-mode="floating"
                                    v-model:value="form.Data"
                                    display-format="dd-MM-yyyy"
                                    type="date"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxDateBox
                                    label="Data Document"
                                    label-mode="floating"
                                    v-model:value="form.DataDoc"
                                    display-format="dd-MM-yyyy"
                                    type="date"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxDateBox
                                    label="Data Scadență"
                                    label-mode="floating"
                                    v-model:value="form.DataScadenta"
                                    display-format="dd-MM-yyyy"
                                    type="date"
                                    :disabled="readonlyLocal"
                                />
                            </div>
                        </div>

                        <!-- Logistics -->
                        <div v-if="data.id === 'logistics'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxLookup
                                    label="Gestiune Intrare"
                                    label-mode="floating"
                                    :data-source="dsGestiune"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    v-model:value="form.GestiuneIntrareId"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Gestiune Ieșire"
                                    label-mode="floating"
                                    :data-source="dsGestiune"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    v-model:value="form.GestiuneIesireId"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Contract"
                                    label-mode="floating"
                                    :data-source="dsNumereContracte"
                                    value-expr="Id"
                                    display-expr="NumeContract"
                                    v-model:value="form.ContractId"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxLookup
                                    label="Proiect"
                                    label-mode="floating"
                                    :data-source="dsProiecte"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    v-model:value="form.ProiectId"
                                    :disabled="readonlyLocal"
                                />
                            </div>
                        </div>

                        <!-- Status -->
                        <div v-if="data.id === 'status'" class="filter-group-inner">
                            <div class="checkbox-grid">
                                <DxCheckBox
                                    text="Stornat/Retur"
                                    :value="viewDoc.StornatRetur"
                                    :disabled="true"
                                />
                                <DxCheckBox
                                    text="Autofacturat"
                                    :value="viewDoc.Autofacturat"
                                    :disabled="true"
                                />
                                <DxCheckBox
                                    text="Emis Tert"
                                    :value="viewDoc.EmisTert"
                                    :disabled="true"
                                />
                                <DxCheckBox
                                    text="Anulat"
                                    :value="viewDoc.Anulat"
                                    :disabled="true"
                                />
                            </div>
                        </div>

                        <!-- Notes -->
                        <div v-if="data.id === 'notes'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxTextArea
                                    label="Explicație"
                                    label-mode="floating"
                                    v-model:value="form.Explicatie"
                                    :height="80"
                                    :disabled="readonlyLocal"
                                />
                            </div>

                            <div class="filter-input">
                                <DxTextArea
                                    label="Observații"
                                    label-mode="floating"
                                    v-model:value="form.Observatii"
                                    :height="80"
                                    :disabled="readonlyLocal"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </DxAccordion>
        </div>

    </div>
</template>

<script>
import DxAccordion from 'devextreme-vue/accordion';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxLookup from 'devextreme-vue/lookup';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxCheckBox from 'devextreme-vue/check-box';
import DxButton from 'devextreme-vue/button';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import DOC_Documente from '@/services/Documente/DOC_Documente';
import notify from 'devextreme/ui/notify';

export default {
    name: 'DocumentDetails',
    components: {
        DxAccordion,
        DxTextBox,
        DxNumberBox,
        DxLookup,
        DxDateBox,
        DxTextArea,
        DxCheckBox,
        DxButton
    },
    props: {
        document: {
            type: Object,
            required: true
        },
        isReadonly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            readonlyLocal: this.isReadonly,
            selectedAccordionKeys: ['identity'],
            accordionItems: [
                { id: 'identity', title: 'Identitate', icon: 'dx-icon-card' },
                { id: 'financial', title: 'Rezumat Financiar', icon: 'dx-icon-money' },
                { id: 'calendar', title: 'Calendar', icon: 'dx-icon-event' },
                { id: 'logistics', title: 'Gestiuni & Proiecte', icon: 'dx-icon-box' },
                { id: 'status', title: 'Statut & Marcaje', icon: 'dx-icon-check' },
                { id: 'notes', title: 'Note & Observații', icon: 'dx-icon-comment' }
            ],

            form: this.getEmptyForm(),

            dsCategorieDocumente: null,
            dsTipDocumente: null,
            dsPartener: null,
            dsValute: null,
            dsGestiune: null,
            dsNumereContracte: null,
            dsProiecte: null,
            dsCursValutar: null
        };
    },
    computed: {
        viewDoc() {
            const d = this.document || {};

            return {
                ...d,
                CategorieId: d.CategorieId ?? d.CategorieID ?? null,
                Tva: d.Tva ?? d.TVA ?? 0,
                ValoareTva: d.ValoareTva ?? d.ValoareTVA ?? 0
            };
        },
        displayCategorieId() {
            if (!this.readonlyLocal) {
                return this.form.CategorieId ?? this.viewDoc.CategorieId ?? null;
            }

            return this.viewDoc.CategorieId ?? null;
        }
    },
    watch: {
        document: {
            async handler(newVal) {
                this.syncFormFromDocument(newVal);
                if (this.dsValute) {
                    await this.resolveValutaId();
                }
            },
            immediate: true
        },
        isReadonly(newVal) {
            this.readonlyLocal = newVal;
        }
    },
    async mounted() {
        this.initDataSources();
        await this.resolveValutaId();
    },
    methods: {
        getEmptyForm() {
            return {
                TipId: null,
                CategorieId: null,
                Numar: '',
                Data: null,
                DataDoc: null,
                DataScadenta: null,
                PartenerId: null,
                ValutaId: null,
                Curs: 1,
                Tva: 0,
                ContractId: null,
                ComandaId: null,
                ProiectId: null,
                GestiuneIntrareId: null,
                GestiuneIesireId: null,
                GestionarIntrareId: null,
                GestionarIesireId: null,
                AgentId: null,
                StructIdEditabil: null,
                DocGeneratAutomatId: null,
                Explicatie: '',
                Observatii: ''
            };
        },

        toDate(value) {
            return value ? new Date(value) : null;
        },

        syncFormFromDocument(source) {
            const doc = source || {};

            this.form = {
                TipId: doc.TipId ?? null,
                CategorieId: doc.CategorieId ?? doc.CategorieID ?? null,
                Numar: doc.Numar ?? '',
                Data: this.toDate(doc.Data),
                DataDoc: this.toDate(doc.DataDoc),
                DataScadenta: this.toDate(doc.Scadenta),
                PartenerId: doc.PartenerId ?? doc.PartenerID ?? null,
                ValutaId: doc.ValutaId ?? doc.ValutaID ?? null,
                Curs: doc.Curs ?? 1,
                Tva: doc.Tva ?? doc.TVA ?? 0,
                ContractId: doc.ContractId ?? doc.ContractID ?? null,
                ComandaId: doc.ComandaId ?? doc.ComandaID ?? null,
                ProiectId: doc.ProiectId ?? doc.ProiectID ?? null,
                GestiuneIntrareId: doc.GestiuneIntrareId ?? doc.GestiuneIntrareID ?? null,
                GestiuneIesireId: doc.GestiuneIesireId ?? doc.GestiuneIesireID ?? null,
                GestionarIntrareId: doc.GestionarIntrareId ?? doc.GestionarIntrareID ?? null,
                GestionarIesireId: doc.GestionarIesireId ?? doc.GestionarIesireID ?? null,
                AgentId: doc.AgentId ?? doc.AgentID ?? null,
                StructIdEditabil: doc.StructIdEditabil ?? doc.StructIDEditabil ?? null,
                DocGeneratAutomatId: doc.DocGeneratAutomatId ?? null,
                Explicatie: doc.Explicatie ?? '',
                Observatii: doc.Observatii ?? ''
            };
        },

        initDataSources() {
            const authHeader = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
            };

            this.dsCategorieDocumente = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsTipDocumente = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Tipuri',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsPartener = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PAR_Parteneri',
                    key: 'ID',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsValute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsGestiune = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'GES_Gestiuni',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsNumereContracte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsProiecte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Proiecte',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsCursValutar = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_CursValutar',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    fieldTypes: {
                        ValutaID: 'Guid'
                    },
                    beforeSend: (e) => e.headers = authHeader
                }
            });
        },

        async resolveValutaId() {
            if (this.form.ValutaId || !this.document?.Valuta) return;
            try {
                this.dsValute.filter(['Simbol', '=', this.document.Valuta]);
                const result = await this.dsValute.load();
                if (result?.length > 0) {
                    this.form.ValutaId = result[0].Id;
                }
            } catch (e) { /* silent */ }
        },

        async onTipChanged(e) {
            this.form.TipId = e.value;

            if (!e.value) {
                this.form.CategorieId = null;
                return;
            }

            try {
                const tip = await this.dsTipDocumente.store().byKey(e.value);
                this.form.CategorieId = tip?.CategorieId ?? null;
            } catch (error) {
                console.error('Eroare la încărcarea categoriei pentru tipul selectat:', error);
            }
        },

        async onValutaChanged(e) {
            this.form.ValutaId = e.value;

            if (!e.value) {
                this.form.Curs = 1;
                return;
            }

            try {
                this.dsCursValutar.filter(['ValutaID', '=', e.value]);
                this.dsCursValutar.sort([{ selector: 'Data', desc: true }]);
                this.dsCursValutar.pageSize(1);

                const result = await this.dsCursValutar.load();

                if (result && result.length > 0) {
                    this.form.Curs = result[0].Curs;
                    return;
                }

                const valuta = await this.dsValute.store().byKey(e.value);
                this.form.Curs = valuta?.Curs ?? 1;
            } catch (error) {
                console.error('Eroare la încărcarea cursului valutar:', error);
                this.form.Curs = 1;
            }
        },

        toggleEdit() {
            if (!this.readonlyLocal) {
                this.syncFormFromDocument(this.document);
                this.readonlyLocal = true;
                return;
            }

            this.readonlyLocal = false;
        },

        enableEdit() {
            this.readonlyLocal = false;
        },

        async saveClicked() {
            try {
                const payload = {
                    TipId: this.form.TipId,
                    Numar: this.form.Numar,
                    Data: this.form.Data,
                    PartenerId: this.form.PartenerId,
                    DataScadenta: this.form.DataScadenta,
                    ValutaId: this.form.ValutaId,
                    Curs: this.form.Curs,
                    ContractId: this.form.ContractId,
                    ComandaId: this.form.ComandaId,
                    ProiectId: this.form.ProiectId,
                    GestiuneIntrareId: this.form.GestiuneIntrareId,
                    GestiuneIesireId: this.form.GestiuneIesireId,
                    GestionarIntrareId: this.form.GestionarIntrareId,
                    GestionarIesireId: this.form.GestionarIesireId,
                    DataDoc: this.form.DataDoc,
                    AgentId: this.form.AgentId,
                    Explicatie: this.form.Explicatie,
                    Observatii: this.form.Observatii,
                    TVA: this.form.Tva ?? 0,
                    StructIdEditabil: this.form.StructIdEditabil,
                    DocGeneratAutomatId: this.form.DocGeneratAutomatId
                };

                await DOC_Documente.update(this.viewDoc.Id, payload);

                notify('Modificările au fost salvate.', 'success', 2000);
                this.readonlyLocal = true;
                this.$emit('refresh-document', this.viewDoc.Id);
            } catch (error) {
                console.error('Error saving document details:', error);
                notify('Eroare la salvarea documentului.', 'error', 4000);
            }
        }
    }
};
</script>

<style scoped>
.sidebar-filters {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.sidebar-header {
    padding: 18px 20px;
    border-bottom: 1px solid #f1f5f9;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-main {
    font-size: 18px;
    color: #ff2c21;
    background: rgba(255, 44, 33, 0.1);
    padding: 6px;
    border-radius: 8px;
}

.sidebar-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}

.close-sidebar-btn-small {
    color: #64748b !important;
    width: 32px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    margin-right: -8px;
}

.close-sidebar-btn-small:hover {
    background-color: #fee2e2 !important;
    color: #ef4444 !important;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.save-header-btn {
    height: 30px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
}

.action-btn-small {
    width: 32px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
}

.action-btn-small:hover {
    background-color: #f1f5f9 !important;
}

.filters-container {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
}

.filters-accordion {
    padding: 0 10px;
}

.accordion-title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 5px;
}

.accordion-title-wrapper i {
    color: #64748b;
    font-size: 16px;
}

.accordion-selected .accordion-title-wrapper i {
    color: #ff2c21;
}

.accordion-title-text {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
}

.accordion-item-content {
    padding: 15px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-top: 1px solid #f8fafc;
}

.filter-group-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.filter-input {
    display: flex;
    flex-direction: column;
}

.form-field-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.checkbox-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.mt-2 {
    margin-top: 8px;
}

.sidebar-footer {
    padding: 20px;
    border-top: 1px solid #f1f5f9;
    background: #fff;
    flex-shrink: 0;
}

.dx-state-disabled {
    opacity: 1 !important;
}

.sidebar-search-btn {
    width: 100% !important;
    height: 44px !important;
    background-color: #ff2c21 !important;
    color: white !important;
    border-radius: 10px !important;
    font-weight: 600 !important;
    box-shadow: 0 4px 12px rgba(255, 44, 33, 0.2) !important;
    transition: all 0.2s ease !important;
}

.sidebar-search-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 44, 33, 0.3) !important;
}

:deep(.dx-accordion-item-opened > .dx-accordion-item-title) {
    background-color: #fff !important;
}

:deep(.dx-accordion-item-title) {
    border-radius: 10px !important;
    margin-bottom: 4px;
    transition: all 0.2s ease;
    background-color: #f8fafc;
    border: 1px solid #f1f5f9 !important;
}

:deep(.dx-accordion-item) {
    border: none !important;
    margin-bottom: 8px;
}

:deep(.dx-texteditor) {
    border-radius: 8px;
    background-color: #fcfcfc;
}

:deep(.dx-lookup-field-wrapper) {
    padding: 0 8px;
}
</style>